
import axios from "axios";
import type { AIResponseType, DocumentItem, RequestType } from "../../types/rfq";

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/rfq`;

const API_BASE_URL_AI = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const buildRfqFormData = (request: RequestType): FormData => {
  const formData = new FormData();

  Object.keys(request).forEach((key) => {
    const value = request[key];

    if (key === "documents") {
      (value || []).forEach((doc: DocumentItem) => {
        formData.append("documents", doc.file);
      });

      formData.append(
        "documents_meta",
        JSON.stringify(
          (value || []).map((doc: DocumentItem) => ({
            name: doc.file.name,
            type: doc.type || "",
          })),
        ),
      );
      return;
    }

    if (Array.isArray(value)) {
      formData.append(key, JSON.stringify(value));
      return;
    }

    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, String(value));
    }
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (user?.id_user) {
    formData.append("user_id", String(user.id_user));
  }

  return formData;
};

export const submitRfq = async (request: RequestType) => {
  const formData = buildRfqFormData(request);

  return axios.post(`${API_BASE_URL}/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export const fillRfqWithAI = async (description: string): Promise<AIResponseType> => {
  const response = await axios.post(`${API_BASE_URL_AI}/ai/rfq-fill`, { description });
  return response.data?.data || response.data || {};
};